import { Type as ClientType, TypeProps } from './client';

export const Type = (props: TypeProps) => {
  return <ClientType {...props} />;
};
